import request from '@/CommonDP/utils/request';
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";
// 文档权限模块接口
export default {
  // 获取专业对应文档权限 企业级
  getListForCheckedSpec(params) {
    return request.post(
      `/enterpriseFolderPrivi/getListForCheckedSpec`,
      params
    );
  },
  // 获取专业角色对应文档权限 企业级
  getListForCheckedRole(params) {
    return request.post(
      `/enterpriseFolderPrivi/getListForCheckedRole`,
      params
    );
  },
  // 保存文档权限 企业级
  updateListForCheckedRole(params) {
    return request.post(`/enterpriseFolderPrivi/batchUpdatePrivi`, params);
  },

  // 获取专业对应文档权限 项目级
  docPermissionFolderList(params) {
    return request.post(`/doc/permission/folder-role-list`, params);
  },
  // 保存问价夹权限 项目级
  updatePermissionOperation(params) {
    return request.post(`/doc/permission/operation`, params);
  },
  updatePermissionUpdate(params) {
    return request.post(`/doc/permission/update`, params);
  },
  batchProductAreaFolderAuth(params) {
    return request.post(`/doc/permission/batchProductAreaFolderAuth`, params);
  },
  // 查询文件夹权限
  docPermissionQuery(folderId, userType) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/doc/permission/query");
    if (isDef(newUrl)) {
      return request.get(`${newUrl}?userType=${userType}&folderId=${folderId}`);
    }
    return request.get(
      `/doc/permission/query?userType=${userType}&folderId=${folderId}`
    );
  },
  // 查询项目成员
  getProjectUsers(prjId) {
    return request.get(`/project/getProjectUsers?projectId=${prjId}`);
  },

  // 查询项目专业
  specpermissionlist(prjId, folderId) {
    return request.get(
      `/doc/permission/spec-list?prjId=${prjId}&folderId=${folderId}`
    );
  },

  // 同步角色权限
  permissionRenew(params) {
    return request.post(`/doc/permission/renew`, params);
  },
  // 同步项目权限
  permissionSyncProject(params) {
    return request.post(`/doc/permission/syncPermissionToProject`, params);
  },
  queryFolderAreaList() {
    return request.get(`/doc/permission/prjFolderArea/typeList`);
  },

  batchRefreshEnterpriseSpecPrivi(enterpriseId) {
    const fixedId = encodeURI(enterpriseId || "");
    return request.post(`/enterpriseFolderPrivi/batch-refresh-folder-privi?enterpriseId=${fixedId}`);
  },

  queryEnterpriseSpecFolderPermissionList(params) {
    return request.post(
      `/enterpriseFolderPrivi/queryEnterpriseSpecFolderPermissionList`,
      params
    );
  },
  queryProductAreaRolePermissionList(params) {
    return request.post(
      `/enterpriseFolderPrivi/queryProductAreaRolePermissionList`,
      params
    );
  },
  queryPrjRolePermissionList(params) {
    return request.post(`/doc/permission/queryPrjRolePermissionList`, params);
  },
  getProductAreaNodeFolderList(prjId) {
    return request.get(
      `/doc/permission/getProductAreaNodeFolderList?prjId=${prjId}`
    );
  },
  queryProductAreaPrjRolePermissionList(params) {
    return request.post(`/doc/permission/queryProductAreaPrjRolePermissionList`, params);
  },
  syncRolePermission(params) {
    return request.post(`/doc/permission/syncRolePermission`, params);
  },
  emptyFinishedArea(prjId) {
    return request.get(
      `/doc/permission/cleanPrjProductAreaChildFolderPermissions?prjId=${prjId}`
    );
  }
};
